<template>
  <div class="progress-circle">
    <canvas :id="`progress-circle-${unique}`" :width="width" :height="height" />
  </div>
</template>

<script>
export default {
  name: "ProgressCircle",
  data() {
    return {
      ele: null,
      progress: 0,
      width: 60,
      height: 60
    };
  },
  props: {
    value: {
      type: Number,
      required: true
    },
    unique: {
      type: String,
      required: true
    },
    colorStart: {
      type: String,
      default: "#FF8900"
    },
    colorStop: {
      type: String,
      default: "#FF5400"
    },
    textColor: {
      type: String,
      default: "#ffffff"
    }
  },
  watch: {
    value: function(){
      this.draw();
    }
  },
  methods: {
    draw: function() {
      let canvas = this.ele;
      let dpr = 1;
      let rad = (Math.PI * 2) / 100;
      this.setWidth();

      canvas.width = this.width * dpr;
      canvas.height = this.height * dpr;

      let ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.scale(dpr, dpr);

      if (this.progress <= this.value) {
        this.progress += 1;
      }
      if (this.progress > this.value) {
        this.progress -= 1;
      }

      this.drawText(ctx);
      this.drawBottomCircle(ctx, rad);
      this.drawBottomArc(ctx, rad);
      this.drawValueArc(ctx, rad);
      requestAnimationFrame(this.draw);
    },

    drawText: function(ctx) {
      ctx.save();
      let r = this.width / 2;
      let size = (0.4 * r) / 2;
      ctx.textAlign = "center";
      ctx.font = `${this.width === 60 ? 10 : 9}px 微软雅黑`;
      ctx.fillStyle = this.textColor;
      ctx.fillText(`${this.progress}%`, r, r + size / 2);
      ctx.restore();
    },

    drawBottomCircle: function(ctx, rad) {
      const lineWidth = (this.width / 60) * 2;
      const x = this.width / 2,
        y = this.width / 2,
        r = this.width / 2 - lineWidth;
      ctx.save();
      ctx.lineCap = "round";
      ctx.strokeStyle = "#323642";
      ctx.lineWidth = lineWidth;
      ctx.beginPath();
      ctx.arc(x, y, r, -Math.PI / 2, -Math.PI / 2 - 100 * rad, true);
      ctx.stroke();
      ctx.closePath();
      ctx.restore();
    },

    drawBottomArc: function(ctx, rad) {
      const lineWidth = (this.width / 60) * 1;
      const offset = 4;
      const x = this.width / 2,
        y = this.width / 2,
        r = this.width / 2 - lineWidth - offset;
      let value = this.progress + 30 >= 100 ? 100 : this.progress + 30;
      let grd = ctx.createLinearGradient(0, 0, value, 0);
      grd.addColorStop(0, this.colorStart);
      grd.addColorStop(1, this.colorStop);

      ctx.save();
      ctx.lineCap = "round";
      ctx.strokeStyle = grd;
      ctx.lineWidth = lineWidth;
      ctx.beginPath();
      ctx.arc(x, y, r, -Math.PI / 2, -Math.PI / 2 - value * rad, true);
      ctx.stroke();
      ctx.closePath();
      ctx.restore();
    },

    drawValueArc: function(ctx, rad) {
      const lineWidth = (this.width / 60) * 6;
      const offset = 2;
      const x = this.width / 2,
        y = this.width / 2,
        r = this.width / 2 - lineWidth - offset;
      let value = this.progress;
      let grd = ctx.createLinearGradient(0, 0, value, 0);
      grd.addColorStop(0, this.colorStart);
      grd.addColorStop(1, this.colorStop);

      ctx.save();
      ctx.lineCap = "round";
      ctx.strokeStyle = grd;
      ctx.lineWidth = lineWidth;
      ctx.beginPath();
      ctx.arc(x, y, r, -Math.PI / 2, -Math.PI / 2 - value * rad, true);
      ctx.stroke();
      ctx.closePath();
      ctx.restore();
    },

    setWidth: function() {
      let docEl = document.documentElement;
      this.width = docEl.clientWidth > 1440 ? 60 : 45;
      this.height = docEl.clientWidth > 1440 ? 60 : 45;
    }
  },
  mounted() {
    this.setWidth();
    this.ele = document.getElementById(`progress-circle-${this.unique}`);
    this.draw();
  }
};
</script>

<style scoped lang="less">
</style>